<script lang="ts">
  import { untrack } from 'svelte'
  import { X } from 'lucide-svelte'
  import { fly } from 'svelte/transition'
  import { flip } from 'svelte/animate'

  let { messages = [] }: { messages?: [string, string][] } = $props()

  let nextId = 0
  const allToasts = untrack(() =>
    messages.map(([type, text]) => ({
      id: nextId++,
      type,
      text,
    }))
  )

  let dismissedIds = $state<number[]>([])
  let toasts = $derived(allToasts.filter(t => !dismissedIds.includes(t.id)))

  const CIRCUMFERENCE = 2 * Math.PI * 12

  function dismiss(id: number) {
    dismissedIds = [...dismissedIds, id]
  }
</script>

{#if toasts.length > 0}
  <div class="fixed top-0 left-0 right-0 z-50 flex flex-col items-center gap-3 p-4 pointer-events-none">
    {#each toasts as toast, i (toast.id)}
      {@const colors = toast.type === 'alert'
        ? 'bg-red-50 border-red-200 text-red-800'
        : 'bg-emerald-50 border-emerald-200 text-emerald-800'}
      <div
        class="pointer-events-auto w-full max-w-md rounded-xl shadow-lg border px-4 py-3 flex items-center gap-3 {colors}"
        animate:flip={{ duration: 300 }}
        transition:fly={{ y: -20, duration: 300 }}
      >
        <p class="grow text-sm font-medium">{toast.text}</p>
        <button
          type="button"
          onclick={() => dismiss(toast.id)}
          class="relative shrink-0 w-7 h-7 flex items-center justify-center rounded-full hover:bg-black/10 transition-colors"
          aria-label="Dismiss"
        >
          <svg class="absolute inset-0 w-7 h-7 -rotate-90" viewBox="0 0 28 28">
            <circle
              cx="14" cy="14" r="12"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              opacity="0.15"
            />
            {#if i === 0}
              <circle
                cx="14" cy="14" r="12"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-dasharray={CIRCUMFERENCE}
                stroke-dashoffset="0"
                stroke-linecap="round"
                class="countdown-ring"
                onanimationend={() => dismiss(toast.id)}
              />
            {/if}
          </svg>
          <X class="w-3.5 h-3.5 relative" />
        </button>
      </div>
    {/each}
  </div>
{/if}

<style>
  .countdown-ring {
    animation: countdown 10s linear forwards;
  }

  @keyframes countdown {
    to {
      stroke-dashoffset: 75.4;
    }
  }
</style>
